"use client";

import { InfoCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Space,
  Tooltip,
  Typography,
} from "antd";
import { BOM } from "../../../../../services/definedMethod";
// import { labelConfig } from "../../../contractbooking.config";
import { labelConfig } from "../../../customer.config";
import PreviewTable from "./PreviewTable";

const { Title, Paragraph } = Typography;
const { Option } = Select;

const dateFormat = "DD-MM-YYYY";

const ProductInformationForm = ({
  onSearch,
  searchParam,
  customerInfo,
  showDetailsForm,
  handleSearchInTable,
  onFinish,
  form,
  initialValues,
  onChangeProduct,
  productData,
  statementCycleOptions,
  isCreateScreen,
  userData,
}) => {
  const isSearchDisabled =
    !searchParam || searchParam?.length < 5 ? true : false;
  console.log(isCreateScreen, "isCreateScreen");

  const dataSections = [
    {
      name: "Agent Name",
      labelValue: customerInfo?.name,
    },
    {
      name: "Agent Code.",
      labelValue: customerInfo?.agentCode,
    },
    {
      name: "Agent Type",
      labelValue: customerInfo?.agentType || "----",
    },
    {
      name: "Agent Branch",
      labelValue: customerInfo?.branch || "----",
    },
  ];

  console.log(customerInfo, "customerInfo");

  return (
    <div className="form-section">
      <h2 style={{ margin: 0, fontSize: "24px" }}>Wallet Setup</h2>
      <p style={{ marginTop: "5px", color: "#6b7280" }}>Retrieve Agent info</p>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ ...initialValues, initiatedBy: userData.username }}
      >
        <Row>
          {isCreateScreen && (
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Space>
                    Agent Code.
                    <Tooltip title="Agent Code.">
                      <InfoCircleOutlined />
                    </Tooltip>
                  </Space>
                }
                name={"customerNumber"}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "80% 17%",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Input
                    onChange={handleSearchInTable}
                    placeholder="Search by agent code"
                    style={{ height: "44px" }}
                  />
                  <Button
                    disabled={isSearchDisabled}
                    style={{
                      border: "1px solid #EAECF0",
                      backgroundColor: !isSearchDisabled
                        ? "#BA24D5"
                        : "#F2F4F7",
                      color: !isSearchDisabled ? "white" : "#98A2B3",
                      // marginTop: 5,
                      padding: "20px 15px",
                    }}
                    onClick={onSearch}
                  >
                    Search
                  </Button>
                </div>
              </Form.Item>
            </Col>
          )}

          <Col />
          {showDetailsForm && (
            <Col span={24} style={{ padding: "0px 8px", marginBottom: 30 }}>
              <PreviewTable data={dataSections} />
            </Col>
          )}

          <Col span={24} style={{ padding: "0px 0px", marginTop: 15 }}>
            <Title style={{ marginInline: 0, marginBlock: 0 }} level={4}>
              Product Information
            </Title>
            <p style={{ color: "#6b7280", marginTop: 8 }}>
              Select a Product For Contract Setup
            </p>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  {labelConfig.productName}
                  <Tooltip title="Select Product Name">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"productId"}
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.productName),
                },
              ]}
            >
              <Select
                showSearch
                disabled={!showDetailsForm}
                allowClear
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? "").includes(
                    input?.toLowerCase(),
                  )
                }
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.productName,
                  "select",
                )}
                // placeholder="Search by product code"
                optionFilterProp="children"
                style={{ height: "44px" }}
                onChange={onChangeProduct}
                options={productData}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label="Wallet Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please enter Wallet name",
                },
              ]}
            >
              <Input
                className="of-bold-disable-input"
                placeholder="Parent Account Holder's Name"
                style={{ height: 44 }}
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label="External ID"
              name="externalId"
              // rules={[
              //   {
              //     required: isCreateScreen,
              //     message: "Please enter External ID",
              //   },
              // ]}
            >
              <Input
                placeholder="e.g. WALLET-01-03"
                className="of-bold-disable-input"
                style={{ height: 44 }}
                disabled={!isCreateScreen}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item label={labelConfig.currency} name={"currencyName"}>
              <Input
                disabled
                className="of-bold-disable-input"
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(labelConfig.currency)}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.createdDate}
              name="submittedOnDate"
              // rules={[
              //   {
              //     required: true,
              //     message: BOM.CheckReqFld(labelConfig.createdDate),
              //   },
              // ]}
            >
              <DatePicker
                disabled
                className="of-bold-disable-input"
                disabledDate={BOM.DisabledAfterCurrentDate}
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.createdDate,
                  "select",
                )}
                style={{ width: "100%", height: 44 }}
                format={dateFormat}
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item label={"Statement cycle"} name={"statementCycle"}>
              <Select
                mode="multiple"
                disabled
                className="of-bold-disable-input"
                style={{ height: "44px" }}
                options={statementCycleOptions}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Inputter
                  <Tooltip title="Person inputting the data">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"initiatedBy"}
            >
              <Input
                value={userData?.username}
                className="of-bold-disable-input"
                placeholder="Matthew Ola"
                style={{ height: "44px" }}
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ProductInformationForm;
